import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AlexChatPage from './pages/AlexChatPage';
import ConceptSortPage from './pages/ConceptSortPage';
import MatchFightersPage from './pages/MatchFightersPage';
import Nbc from './pages/Nbc';
import { ChatApiProvider } from './contexts/ChatApiContext';

const App: React.FC = () => {
    return (
        <Router>
            <ChatApiProvider>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/alex" element={<AlexChatPage />} />
                    <Route path="/alex/:conversationId" element={<AlexChatPage />} />
                    <Route path="/concept-sort" element={<ConceptSortPage />} />
                    <Route path="/match-fighters" element={<MatchFightersPage />} />
                    <Route path="/nbc" element={<Nbc />} />
                    <Route path="/api-test" element={<Navigate to="/" replace />} />
                </Routes>
            </ChatApiProvider>
        </Router>
    );
};

export default App;